import { alpha } from '@mui/material/styles';

const BORDER_ALPHA = 0.4;
const BG_ALPHA = 0.06;

export const noteStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 16px',
  borderRadius: '8px',
  borderLeft: ({ palette }) => `3px solid ${palette.info.main}`,
  border: ({ palette }) => `1px solid ${alpha(palette.info.main, BORDER_ALPHA)}`,
  backgroundColor: ({ palette }) => alpha(palette.info.main, BG_ALPHA),
};

export const iconStyles = {
  display: 'flex',
  flexShrink: 0,
  marginTop: '2px',
  color: ({ palette }) => palette.info.main,
};

export const textStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const emphasisStyles = {
  color: ({ palette }) => palette.text.primary,
};
